import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col overflow-hidden pt-4 w-full bg-white" }
const _hoisted_2 = { class: "flex flex-row h-screen py-4 overflow-y-auto" }
const _hoisted_3 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", { class: "mt-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", { class: "mt-2" }, null, -1)
const _hoisted_6 = { class: "flex flex-row py-4" }
const _hoisted_7 = { class: "mt-4 w-3/4" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = { class: "pb-2 w-6/12" }
const _hoisted_10 = { class: "pl-5 pb-2 w-6/12" }
const _hoisted_11 = { class: "flex flex-row pb-4" }
const _hoisted_12 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = { class: "py-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-300 text-12px mb-2" }, " Tanggal Dibuat ", -1)
const _hoisted_16 = { class: "my-1 text-black-lp-300" }
const _hoisted_17 = { class: "text-gray-lp-500" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-gray-lp-300 text-12px mb-2" }, " Tanggal Diubah ", -1)
const _hoisted_19 = { class: "my-1 text-black-lp-300" }
const _hoisted_20 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          label: "Client Name",
          class: "py-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dataDetail.accountRefName), 1)
          ]),
          _: 1
        }),
        _hoisted_4,
        _createVNode(_component_Title, {
          label: "Data Client Booking Template",
          class: "py-6 text-20px"
        }),
        _hoisted_5,
        (_ctx.tempExcel.length > 0)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_DataWrapper, {
                      label: "Header Client",
                      class: "w-full",
                      value: " "
                    }),
                    _createVNode(_component_DataWrapper, {
                      label: "Header Genesis",
                      class: "w-full ml-8",
                      value: " "
                    })
                  ]),
                  _createVNode("table", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tempExcel, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", _hoisted_9, [
                          _createVNode(_component_lp_input, {
                            class: "my-6",
                            modelValue: item.sourceHeader,
                            "onUpdate:modelValue": ($event: any) => (item.sourceHeader = $event),
                            placeholder: "Masukan header baru"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createVNode("td", _hoisted_10, [
                          _createVNode(_component_Select, {
                            value: item.genesisHeader,
                            dataSelect: _ctx.sheetDefaultGenesis,
                            onOpenMenu: ($event: any) => (_ctx.openMenu(index)),
                            onCloseMenu: ($event: any) => (_ctx.closeMenu(index)),
                            onChooseSelect: _ctx.onSelectSheet,
                            class: "w-full",
                            isOpenMenu: item.activitySelect
                          }, null, 8, ["value", "dataSelect", "onOpenMenu", "onCloseMenu", "onChooseSelect", "isOpenMenu"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_button_fill, {
                  custom: "px-10 bg-red-lp-200",
                  title: "Tambahkan Header",
                  onClick: _ctx.onAddHeader
                }, null, 8, ["onClick"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.createdAt), 1),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.dataDetail.createdBy), 1)
          ]),
          _hoisted_18,
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: "Perubahan Config Berhasil",
      onSubmit: _ctx.successSubmit,
      message: `Perubahan client booking config berhasil tersimpan`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit"]), [
      [_vShow, _ctx.isSuccess]
    ])
  ]))
}